export default "__VITE_ASSET__c18e4501__"